import React from 'react'
import { CCard, CCardBody, CBadge } from '@coreui/react-pro'

const CommunityTopPlayersModal = ({ item }) => {
  const { payload } = item

  if (!payload || !payload.players || payload.players.length === 0) {
    return <p>No player data available</p>
  }

  const getMedalEmoji = (rank) => {
    const medals = { 1: '🥇', 2: '🥈', 3: '🥉' }
    return medals[rank] || `#${rank}`
  }

  return (
    <div>
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <h5>Top 5 Players in round {item?.round_number}</h5>
        <p style={{ marginBottom: '10px', color: '#666' }}>{payload.description}</p>
        <CBadge color="success">TOP PLAYERS</CBadge>
      </div>

      <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
        {payload.players.map((player, index) => (
          <CCard key={index} style={{ marginBottom: '12px' }}>
            <CCardBody style={{ padding: '12px' }}>
              <div
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <div>
                  <div style={{ marginBottom: '6px' }}>
                    <strong>
                      {getMedalEmoji(player.rank)} {player.player_name}
                    </strong>
                  </div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#0c63e4' }}>
                    {player.fantasy_points || 0}
                  </div>
                  <small style={{ color: '#666' }}>Points</small>
                </div>
              </div>
            </CCardBody>
          </CCard>
        ))}
      </div>
    </div>
  )
}

export default CommunityTopPlayersModal
